import {convertToBoolean, convertToNumber, isNullOrUndefined} from "../commonUtilities";
import {isString} from "../Types/typeUtilities";
import * as storageTypes from "./storageTypes";
import {ROLES} from "../../Components/Authorize/roleConstants";

function storageGet<T = unknown>(key: string): T | undefined {
    const item = localStorage.getItem(key);
    if (item === null) return undefined;
    try { return JSON.parse(item) as T; }
    catch { return item as unknown as T; }
}

function storageSet(key: string, value: unknown): void {
    localStorage.setItem(key, JSON.stringify(value));
}

function storageRemove(key: string): void {
    localStorage.removeItem(key);
}

export function isLoggedIn(): boolean {
    const userIdentity = storageGet<string>(storageTypes.CURRENT_USER);
    return isString(userIdentity);
}

export function isAdmin(): boolean {
    const roles = storageGet<unknown[]>(storageTypes.ROLES);
    return !isNullOrUndefined(roles) ? roles.includes(ROLES.FimcAdmin) || roles.includes(ROLES.SystemAdmin) : false;
}

export function isFimcAdmin(): boolean {
    const roles = storageGet<unknown[]>(storageTypes.ROLES);
    return !isNullOrUndefined(roles) ? roles.includes(ROLES.FimcAdmin) : false;
}

export function getRoles(): (number | undefined)[] {
    const roles = storageGet<unknown[]>(storageTypes.ROLES);
    return roles ? roles.map((role: unknown) => convertToNumber(role)) : [];
}

export function getPatronRole(): number | undefined {
    return convertToNumber(storageGet(storageTypes.PATRON_ROLE));
}

export function getPatronSubType(): number | undefined {
    return convertToNumber(storageGet(storageTypes.PATRON_SUBTYPE));
}

export function getFullName(): string {
    return storageGet<string>(storageTypes.FULL_NAME) ?? "";
}

export function getCanUserAssignDelegate(): boolean {
    return convertToBoolean(storageGet(storageTypes.CAN_ASSIGN_DELEGATE));
}

export function updateFullName(firstName: string, lastName: string): void {
    storageSet(storageTypes.FULL_NAME, `${firstName}  ${lastName}`);
}

export function persistLogin(userIdentity: string, email: string, fullName: string, roles: unknown[], canAssignDelegate: boolean, patronRole: unknown, patronSubtype: unknown): void {
    storageSet(storageTypes.CURRENT_USER, userIdentity);
    storageSet(storageTypes.EMAIL, email);
    storageSet(storageTypes.FULL_NAME, fullName);
    storageSet(storageTypes.ROLES, isNullOrUndefined(roles) ? [] : roles);
    storageSet(storageTypes.CAN_ASSIGN_DELEGATE, canAssignDelegate);
    storageSet(storageTypes.PATRON_ROLE, patronRole);
    storageSet(storageTypes.PATRON_SUBTYPE, patronSubtype);
}

export function desistLogin(): void {
    storageRemove(storageTypes.CURRENT_USER);
    storageRemove(storageTypes.EMAIL);
    storageRemove(storageTypes.FULL_NAME);
    storageRemove(storageTypes.ROLES);
}

export function getLoggedInUser(): string {
    return storageGet<string>(storageTypes.CURRENT_USER) ?? "";
}

export const storageUtilitiesProps = {isLoggedIn, isAdmin, getRoles, persistLogin, desistLogin, getLoggedInUser, updateFullName};
